import { z } from "zod";

import { zPropertySchemaAssociationFormData } from "~/features/admin/propertySchemas";
import type { GetDataSourceTemplateDetailQuery, GetDataSourceTemplatesQuery } from "./gqls";

export type DataSourceTemplateListRaw = GetDataSourceTemplatesQuery["dataSourceTemplates"][number];
export type DataSourceTemplateDetailRaw = GetDataSourceTemplateDetailQuery["dataSourceTemplates"][number];

/** UI-ready row for the list table. */
export interface DataSourceTemplateRow {
  id: string;
  name: string;
  isDeactivated: boolean;
}

/** Read-only property-schema row for the detail view. */
export interface PropertySchemaRow {
  id: string;
  name: string;
  description: string;
  position: number;
  required: boolean;
  unique: boolean;
  propertyTypeId: string;
  propertyAttributeTypeId: string | null;
  selectOptions: Array<{ value: string; label?: { ja?: string; en?: string } }>;
  urlAllowList: Array<{ value: string; regex: string }>;
}

/** Fields shown in the read-only detail view. */
export interface DataSourceTemplateDetailUI {
  id: string;
  name: string;
  isDeactivated: boolean;
  createdAt: string | null;
  updatedAt: string | null;
  deactivatedAt: string | null;
  propertySchemas: PropertySchemaRow[];
}

/**
 * Form shape for create + edit. `id` is set in edit mode only. Includes
 * propertySchemaAssociations so the embedded schema editor stays type-aligned
 * with `useForm`.
 */
export const zDataSourceTemplateFormData = z.object({
  id: z.string().optional(),
  name: z.string().min(1),
  propertySchemaAssociations: z.array(zPropertySchemaAssociationFormData).optional(),
});
export type DataSourceTemplateFormData = z.infer<typeof zDataSourceTemplateFormData>;
export const zDataSourceTemplateFormDataKeys = zDataSourceTemplateFormData.keyof();
